/**
 * i18n 桥接工具
 * 用于在 Pinia store 等非组件上下文中访问 i18n 翻译函数
 * 因为 useI18n() 只能在 Vue 组件的 setup() 中调用
 */

type TranslateFunction = (key: string, defaultMsg?: string) => string

let _t: TranslateFunction | null = null

/**
 * 设置全局翻译函数（在应用初始化时调用）
 */
export function setI18nTranslator(t: TranslateFunction) {
  _t = t
}

/**
 * 获取翻译函数（在 store 等非组件上下文中使用）
 * 如果尚未设置，返回 fallback 函数（直接返回 key 或 defaultMsg）
 */
export function getTranslator(): TranslateFunction {
  if (_t) {
    return _t
  }
  // Fallback: 返回 defaultMsg 或 key
  return (key: string, defaultMsg?: string) => defaultMsg || key
}
